import { useEffect } from 'react';
import { logMapWidgetDoc } from './logDocumentation';
import { QueryParser } from '../common/SearchParamsParser';

import '@assets/scss/map-widget.scss';

const MapWidget = () => {
  useEffect(() => {
    logMapWidgetDoc();
  }, []);

  return <QueryParser />;
};

export default MapWidget;
